<template>
  <div class="fieldset-user-edit-mail-password-parts">
    <fieldset-confirm-parts
      class="fieldset-user-edit-mail-password-parts__fieldset"
      :label="label"
      v-model="mailOrPasswrodValue"
      :isMask="isMask"
    />
    <atom-input-button
      class="fieldset-user-edit-mail-password-parts__confirm"
      :linkText="$t('common.edit')"
      colorType="secondary"
      size="medium"
      :isDisabled="false"
      @push="emitEnter"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import FieldsetConfirmParts from '@/components/common/form/FieldsetConfirmParts.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'

/**
 * マイページ: 会員情報変更 メールアドレス フィールドパーツ
 */
export default defineComponent({
  name: 'FieldsetUserEditMailPasswordParts',
  components: {
    FieldsetConfirmParts,
    AtomInputButton,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    isMask: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const mailOrPasswrodValue = computed(() => props.value)
    return {
      mailOrPasswrodValue,
    }
  },
  methods: {
    emitEnter() {
      /**
       * emitEnter
       * 変更ボタン押下処理
       */
      this.$emit('push')
    },
  },
})
</script>

<style lang="scss" scoped>
.fieldset-user-edit-mail-password-parts {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 24px 0 0;

  &__fieldset {
    max-width: calc(100% - 96px);
    border: none;
    padding: 0;

    &:first-child {
      margin: 0;
    }
  }
}
</style>
